import type {ToggleSwitchV2Size} from '@Components/toggle-switch-v2';
import type {ReactElement} from 'react';
import type {TeamsUpsellSource} from '@Libraries/teams-upsell.library';

export interface ShareInTeamToggleBarProps {
  state: ShareInTeamBarState;
  upsellSource: TeamsUpsellSource;
  onStateUpdate: (state: ShareInTeamBarState) => void;
  isCurrentlyLoading?: boolean;
  customClasses?: string;
  toggleSize?: ToggleSwitchV2Size;
  shareInTeamIcon?: ReactElement<any>;
}

export enum ShareInTeamBarState {
  ACTIVE = 1,
  INACTIVE = 2,
  UPSELLING = 3,
}
